<template>

<com-item name="players.mostplays" :has-more="true" v-on:more="onMoreClick" :size="size" :is-list="true" :loading="loading" :is-empty="!active" title="Most plays">

	<template v-slot:about>

		<p>Players played with the most.</p>

	</template>

	<template v-slot:stats>

		<app-user type="player" :item="item" v-for="(item, index) in data" subdate="Last played with on" count-text="play" :key="index" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

	computed: {

		loading: function() {

			return this.fetching === 'all' 

		},

		data: function() {

			return this.$store.getters['page/insights/players/mostplays']

		},

		active: function() {

			return this.data.length && !this.loading

		}

	},

	methods: {

		onMoreClick: function() {
		
			this.$pubsub.$emit('panel.open', {
				type: 'insightsPlayersMostplays'
			})
		
		}

	}

}

</script>

<style scoped>

</style>